export default "__VITE_ASSET__51BYXwvt__"